/**
 * Easing function
 * @param  {Number} currentTime Current time
 * @param  {Number} start       Start position
 * @param  {Number} change      Position difference
 * @param  {Number} duration    Tween time
 * @return {Number}             Next step of position change
 */
export function easeInOut(currentTime, start, change, duration) {
  let _currTime = currentTime;

  _currTime /= duration / 2;
  if (_currTime < 1) {
    return (change / 2) * _currTime * _currTime + start;
  }
  _currTime -= 1;
  return (-change / 2) * (_currTime * (_currTime - 2) - 1) + start;
}

/**
 * Method for smooth scrolling page
 * @param  {Object} element    DOM Elemenet to target
 * @param  {Number} to         Target position
 * @param  {Number} duration   Time of tween
 * @param  {Function} callback Function to be called after animation
 * @return {Undefined} Returns nothing
 */
export function scrollToTop(element, to, duration, callback) {
  const start = element.scrollTop,
    change = to - start,
    increment = 20;

  const animateScroll = elapsedTime => {
    const elapsed = elapsedTime + increment;
    const position = easeInOut(elapsed, start, change, duration);

    element.scrollTop = position;
    if (elapsed < duration) {
      setTimeout(() => {
        animateScroll(elapsed);
      }, increment);
    } else if (callback) {
      return callback();
    }
  };

  animateScroll(0);
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/scrollHelpers.js